import useAuth from '@fhs-legacy/frontend/src/hooks/auth/use-auth';
import useDebounceEffect from '@fhs-legacy/frontend/src/hooks/use-debounce-effect';
import { useCartContext } from '@fhs-legacy/frontend/src/state/cart';
import { selectors, useAppSelector } from '@fhs-legacy/frontend/src/state/global-state';
import { IAppliedRewards } from '@fhs-legacy/frontend/src/state/loyalty/hooks/types';
import { useOffersContext } from '@fhs-legacy/frontend/src/state/offers';
import { useStoreContext } from '@fhs-legacy/frontend/src/state/store';

export function useCartPriceOrder() {
  /* initializes the price order call and the getOrder polling, available on cart and checkout as well as other pages;
  has an interval check where it will price after 15 minutes also found in car context
  */
  const appliedLoyaltyRewards: IAppliedRewards = useAppSelector(
    selectors.loyalty.selectAppliedLoyaltyRewards
  );
  const isRewardApplied = Object.keys(appliedLoyaltyRewards).length;

  const selectedOffer = useAppSelector(selectors.loyalty.selectSelectedOffer);
  const incentiveApplied = isRewardApplied || selectedOffer;

  const {
    cartEntries,
    tryPricing,
    serverOrder,
    serverOrderLoading,
    serviceMode,
    shouldSkipPriceOrder,
    setShouldSkipPriceOrder,
    rewardsApplied,
  } = useCartContext();

  const appliedOffers = useAppSelector(selectors.loyalty.selectAppliedOffers);
  const { isStoreAvailable } = useStoreContext();
  const { selectedOffer: selectedCBAOffer, selectedOfferCartEntry } = useOffersContext();
  const { user } = useAuth();
  const rewardChanged = user?.details?.loyaltyTier;

  const handleRestoreCartErrorPricing = () =>
    shouldSkipPriceOrder && setShouldSkipPriceOrder(false);

  useDebounceEffect(
    () => {
      if (!isStoreAvailable || !serviceMode) {
        return;
      }

      handleRestoreCartErrorPricing();
      tryPricing();
    },
    250,
    [
      cartEntries,
      appliedOffers,
      isStoreAvailable,
      serviceMode,
      selectedCBAOffer,
      selectedOfferCartEntry,
      rewardChanged,
      rewardsApplied,
    ]
  );

  return {
    serverOrder,
    serverOrderLoading,
    serverOrderTotal: serverOrder?.cart?.subTotalCents,
    incentiveApplied,
  };
}
